import Cookies from 'js-cookie';
import {
    useEffect,
    useState,
} from 'react';

class UiStorage {
    setItem = (name: string, value: any) => {
        localStorage.setItem(name, value);

        Cookies.set(name, value);
    };

    getItem = (name: string) => localStorage.getItem(name) ?? Cookies.get(name) ?? null;

    removeItem = (name: string) => {
        localStorage.removeItem(name);
        Cookies.remove(name);
    };
}

const UiStorageSingleton = new UiStorage();

export const useUiStorage = (name: string) => {
    const [ value, setValue ] = useState<any>(UiStorageSingleton.getItem(name));

    useEffect(() => {
        UiStorageSingleton.setItem(name, value);
    }, [ value, name ]);

    return [ value, setValue ];
};

export default UiStorageSingleton;
